import { useEffect } from 'react';
import { IItemsModifier, IItemsModifierSet, REQUIRED, isModifierRequiredOrOptional } from './common';
import styles from './common.module.scss';
import { useIntl } from 'react-intl';

interface ISampleModifierProps {
	minimumModifiers: number;
	maximumModifier: number;
	totalModifierAvailable: number;
	modifiersArray: IItemsModifier[] | undefined;
	selectedModifierSets: string[];
	modifierSet: IItemsModifierSet;
	requiredModifierErr?: boolean | undefined;
	requiredModifierRef?: string | undefined;
	setRequiredModifierErr?: React.Dispatch<React.SetStateAction<boolean>> | undefined;
}

const RequiredModifier: React.FC<ISampleModifierProps> = ({
	minimumModifiers,
	maximumModifier,
	totalModifierAvailable,
	modifiersArray,
	selectedModifierSets,
	modifierSet,
	requiredModifierErr,
	requiredModifierRef,
	setRequiredModifierErr,
}) => {
	const intl = useIntl();
	let maximumModifiers = maximumModifier;
	if (maximumModifiers >= totalModifierAvailable) {
		maximumModifiers = totalModifierAvailable;
	}
	const matchingElements = selectedModifierSets.filter(
		(item) =>
			modifiersArray?.some((modifierItem: IItemsModifier) => modifierItem.key === item) ?? false
	);

	const RequiredTick: React.FC = () => {
		useEffect(() => {
			if (setRequiredModifierErr && requiredModifierRef === modifierSetDetails?.ref) {
				setRequiredModifierErr(false);
			}
		}, []);
	
		return <span className={styles.modifierSelected}>{intl.formatMessage({ id: 'component:modifier:required:label' })}</span>;
	};
	

	const modifierSetDetails = modifierSet?.modifierSetDetails;
	const isError = requiredModifierRef === modifierSetDetails?.ref && requiredModifierErr;

	const isModifierSelected = (): JSX.Element => {
		if (minimumModifiers && maximumModifiers && minimumModifiers === maximumModifiers) {
			if (matchingElements.length >= maximumModifiers) {
				return <RequiredTick />;
			}
		} else if (minimumModifiers && maximumModifiers && minimumModifiers < maximumModifiers) {
			if (matchingElements.length >= minimumModifiers && matchingElements.length <= maximumModifiers) {
				return <RequiredTick />;
			}
		} else if (maximumModifiers) {
			if (matchingElements.length <= maximumModifiers) {
				return <RequiredTick />;
			}
		}
		return <span className={`${styles.modifierRequired} ${isError ? styles.modifierRequiredErrText : ''}`}>{intl.formatMessage({ id: 'component:modifier:required:label' })}</span>;
	};

	return (
		<div className={styles.modifierName}>
			{isModifierRequiredOrOptional(minimumModifiers) === REQUIRED ? (
				isModifierSelected()
			) : (
				<div className={styles.modifierOptional}>{intl.formatMessage({ id: 'component:modifier:optional:label' })}</div>
			)}
		</div>
	);
};

export default RequiredModifier;
